export class UIHelper {
  static findPosition(oElement) {
    if (typeof oElement.offsetParent != 'undefined') {
      for (var posX = 0, posY = 0; oElement; oElement = oElement.offsetParent) {

        if (oElement && oElement.classList && oElement.classList.contains('item')) {
          continue;
        }

        posX += oElement.offsetLeft;
        posY += oElement.offsetTop;
      }
      return [posX, posY];
    } else {
      return [oElement.x, oElement.y];
    }
  }

  static getCoordinates(e, scrollContainer) {
    let PosX = 0;
    let PosY = 0;
    let ImgPos: any;
    ImgPos = this.findPosition(e.target);
    if (e.pageX || e.pageY) {
      PosX = e.pageX;
      PosY = e.pageY;
    } else if (e.clientX || e.clientY) {
      PosX = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
      PosY = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }
    PosX = PosX - ImgPos[0];
    PosY = PosY - ImgPos[1];

    if (scrollContainer && scrollContainer.scrollTop) {
      PosY = PosY + scrollContainer.scrollTop;
    }

    return {
      x: PosX,
      y: PosY,
    };
  }
}
